import { Injectable, OnDestroy } from '@angular/core';
import { io, Socket } from 'socket.io-client';
import { Observable, Subject } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { AuthService } from '../../auth/services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class NotificationSocketService implements OnDestroy {
  private socket: Socket | null = null;
  private readonly events = new Map<string, Subject<unknown>>();
  private readonly namespace = '/notifications';

  constructor(private readonly authService: AuthService) {}

  connect(): void {
    if (this.socket) return;
    if (!this.authService.getAccessToken()) return;

    this.socket = io(`${environment.url}${this.namespace}`, {
      auth: (done) => done({ token: this.authService.getAccessToken() }),
      autoConnect: true,
      reconnection: true,
      transports: ['websocket', 'polling']
    });

    this.socket.onAny((eventName: string, payload: unknown) => {
      this.events.get(eventName)?.next(payload);
    });
    this.socket.io.on('reconnect', () => {
      this.events.get('socket:reconnected')?.next(undefined);
    });
  }

  disconnect(): void {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
    }
  }

  fromEvent<T>(eventName: string): Observable<T> {
    let eventSubject = this.events.get(eventName);
    if (!eventSubject) {
      eventSubject = new Subject<unknown>();
      this.events.set(eventName, eventSubject);
    }
    return eventSubject.asObservable() as Observable<T>;
  }

  ngOnDestroy(): void {
    this.disconnect();
    this.events.forEach((eventSubject) => eventSubject.complete());
    this.events.clear();
  }
}
